const isArray = parameter => {
  const _isArray = parameter.constructor === Array;
  // parameter instanceof Array;
  // Array.isArray(parameter);
  return _isArray;
};

const isObject = parameter => {
  const _isObject = typeof parameter === 'object' && parameter !== null;

  return _isObject;
};

function isJson(str) {
  try {
    const data = JSON.parse(str);
    return { data, success: true };
  } catch (e) {
    return { data: null, success: false };
  }
}

export { isArray, isObject, isJson };
